import { Component } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import {
  UpgradeInterest,
  UpgradeRequestService,
} from '../../api/upgrade-request.service';
import { GT2PageAbstract } from '../abstract/GT2PageAbstract';
import { IconsService } from '../../services/icons.service';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';

/**
 * Page « Demander une mise à niveau [PRO] » (menu Mise à niveau → Commander, bouton
 * « Commander » des panneaux). V1 : cases « Nous sommes intéressés à » + message →
 * POST /v1/paywall/upgrade-request (courriel interne à l'équipe GT).
 */
@Component({
  selector: 'app-upgrade-request',
  templateUrl: './upgrade-request.component.html',
  styleUrls: ['./upgrade-request.component.scss'],
})
export class UpgradeRequestComponent extends GT2PageAbstract {
  static readonly MESSAGE_MAX = 2048;

  upgradeIcon: string = IconsService.UPGRADE;
  form: UntypedFormGroup;
  interests: { key: UpgradeInterest; label: string }[] = [
    { key: 'SUBMISSIONS', label: 'UPGRADE_REQUEST.INTEREST_SUBMISSIONS' },
    { key: 'AUTOMATIONS', label: 'UPGRADE_REQUEST.INTEREST_AUTOMATIONS' },
    { key: 'INTEGRATIONS', label: 'UPGRADE_REQUEST.INTEREST_INTEGRATIONS' },
  ];
  sending: boolean = false;
  sent: boolean = false;
  messageMax: number = UpgradeRequestComponent.MESSAGE_MAX;

  constructor(
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private upgradeRequestService: UpgradeRequestService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private router: Router,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);
    this.form = this.formBuilder.group({
      SUBMISSIONS: [false],
      AUTOMATIONS: [false],
      INTEGRATIONS: [false],
      message: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(UpgradeRequestComponent.MESSAGE_MAX),
        ],
      ],
    });
  }

  send(): void {
    if (this.form.invalid || this.sending) {
      return;
    }
    const value = this.form.value;
    const interests = this.interests
      .map((i) => i.key)
      .filter((key) => value[key] === true);

    this.sending = true;
    this.upgradeRequestService
      .send({ message: (value.message ?? '').trim(), interests })
      .subscribe({
        next: () => {
          this.sending = false;
          this.sent = true;
          this.toastr.success(
            this.translate.instant('UPGRADE_REQUEST.SENT_TOAST'),
          );
        },
        error: (error) => {
          this.sending = false;
          this.handleAPIError(
            error,
            this.dialog,
            this.toastr,
            this.translate.instant('GENERIC.ERRORS.GENERIC') + ' UPG001',
            this.router,
          );
        },
      });
  }

  /** « Envoyer une autre demande » : formulaire vierge. */
  reset(): void {
    this.form.reset({
      SUBMISSIONS: false,
      AUTOMATIONS: false,
      INTEGRATIONS: false,
      message: '',
    });
    this.sent = false;
  }
}
